<template lang="html">
  <div class="custom-booking-step py-1">
    <div class="mb-6 mx-2">
      <div class="title mb-2">
        {{(item.expanded_resources || []).map(r => r.title).join(', ')}}
      </div>
      <div class="text--secondary">
        {{item.guests}} personer, {{item.from_local}} - {{item.to_local}}
      </div>

      <div class="mb-6">
        <div class="" v-if="isRequestTooLate">
          Tyvärr går det inte att beställa till mat i bokningen då den ligger för nära i tid.
        </div>
        <div v-else>
          <!-- Catering checkboxes start -->
          <div class="">
            <div class="">
              <div class="d-flex align-center">
                <v-checkbox
                  :label="packageProduct.title"
                  v-model="cateringPackage"
                  hide-details
                  class="mt-0"
                ></v-checkbox>
                <v-spacer></v-spacer>
                <div class="text--secondary mx-2 text-end">
                  {{ packageProduct.price }}:-/pers
                </div>
                <v-btn icon text @click="$dialog({title: packageProduct.title, message: packageProduct.subtitle + '\n\n' + (Math.round((packageProduct.price * 100) / ((100 + packageProduct.vat) / 100)) / 100).toFixed(2).replace('.', ',') + ' kr/pers exkl. moms'})">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </div>
              <v-text-field
                v-if="cateringPackage"
                label="Antal"
                type="tel"
                v-model="cateringPackageCount"
                :placeholder="''+item.guests"
                outlined
                class="mt-2 ml-8"
                :rules="[validNumber]"
              ></v-text-field>
            </div>

            <div class="" v-if="!cateringPackage">
              <div class="">
                <div class="d-flex align-center" v-if="morning">
                  <v-checkbox
                    :label="products.morning_fika_count.title"
                    v-model="morningFika"
                    hide-details
                    class="mt-0"
                  ></v-checkbox>
                  <v-spacer></v-spacer>
                  <div class="text--secondary mx-2 text-end">
                    {{ products.morning_fika_count.price }}:-/pers
                  </div>
                  <v-btn icon text @click="$dialog({title: products.morning_fika_count.title, message: products.morning_fika_count.subtitle + '\n\n' + (Math.round((products.morning_fika_count.price * 100) / ((100 + products.morning_fika_count.vat) / 100)) / 100).toFixed(2).replace('.', ',') + ' kr/pers exkl. moms'})">
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </div>
                <v-text-field
                  v-if="morningFika"
                  label="Antal"
                  type="tel"
                  v-model="morningFikaCount"
                  :placeholder="''+item.guests"
                  outlined
                  class="mt-2 ml-8"
                  :rules="[validNumber]"
                ></v-text-field>
              </div>

              <div class="">
                <div class="d-flex align-center">
                  <v-checkbox
                    :label="products.lunch_count.title"
                    v-model="lunch"
                    hide-details
                    class="mt-0"
                  ></v-checkbox>
                  <v-spacer></v-spacer>
                  <div class="text--secondary mx-2 text-end">
                    {{ products.lunch_count.price }}:-/pers
                  </div>
                  <v-btn icon text @click="$dialog({title: products.lunch_count.title, message: products.lunch_count.subtitle + '\n\n' + (Math.round((products.lunch_count.price * 100) / ((100 + products.lunch_count.vat) / 100)) / 100).toFixed(2).replace('.', ',') + ' kr/pers exkl. moms'})">
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </div>
                <v-text-field
                  v-if="lunch"
                  label="Antal"
                  type="tel"
                  v-model="lunchCount"
                  :placeholder="''+item.guests"
                  outlined
                  class="mt-2 ml-8"
                  :rules="[validNumber]"
                ></v-text-field>
              </div>

              <div class="">
                <div class="d-flex align-center"  v-if="!halfDay || !morning">
                  <v-checkbox
                    :label="products.afternoon_fika_count.title"
                    v-model="afternoonFika"
                    hide-details
                    class="mt-0"
                  ></v-checkbox>
                  <v-spacer></v-spacer>
                  <div class="text--secondary mx-2 text-end">
                    {{ products.afternoon_fika_count.price }}:-/pers
                  </div>
                  <v-btn icon text @click="$dialog({title: products.afternoon_fika_count.title, message: products.afternoon_fika_count.subtitle + '\n\n' + (Math.round((products.afternoon_fika_count.price * 100) / ((100 + products.afternoon_fika_count.vat) / 100)) / 100).toFixed(2).replace('.', ',') + ' kr/pers exkl. moms'})">
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </div>
                <v-text-field
                  v-if="afternoonFika"
                  label="Antal"
                  type="tel"
                  v-model="afternoonFikaCount"
                  :placeholder="''+item.guests"
                  outlined
                  class="mt-2 ml-8"
                  :rules="[validNumber]"
                ></v-text-field>
              </div>

            </div>

          </div>
          <!-- Catering checkboxes end -->
        </div>
      </div>

      <div v-if="cateringPackage || morningFika || lunch || afternoonFika">
        <div class="">
          Har ni några allergier eller specialkost?
        </div>
        <v-textarea
          v-model="allergies"
          outlined
          class="mt-1"
          rows="1"
          auto-grow
        ></v-textarea>
      </div>

      <div class="" v-if="cateringPackage || morningFika || lunch || afternoonFika">
        <div class="">
          Vilka tider önskas fika eller lunch serveras?
        </div>
        <v-textarea
          v-model="cateringTime"
          outlined
          class="mt-1"
          rows="1"
          auto-grow
        ></v-textarea>
      </div>

      <seating-input
        :calendar="calendar"
        v-model="seating"
        :item="item"
        label="Möblering"
        outlined
      ></seating-input>

      <div class="">
        <div class="">
          Har ni behov av teknisk uppkoppling? På vilket sätt? Exempelvis för att visa presentation eller koppla upp er till annat möte?
        </div>
        <v-textarea
          v-model="needUplink"
          outlined
          class="mt-1"
          rows="1"
          auto-grow
        ></v-textarea>
      </div>

      <div class="">
        <div class="">
          Vill ni komma innan bokningen för att stämma av tekniken?
        </div>
        <v-textarea
          v-model="preCheckTech"
          outlined
          class="mt-1"
          rows="1"
          auto-grow
        ></v-textarea>
        <!-- <v-checkbox label="Ja" v-model="preCheckTech"></v-checkbox> -->
      </div>

      <div class="">
        <v-textarea
          label="Övrigt"
          v-model="item.comment"
          outlined
          class="mt-1"
          rows="1"
          auto-grow
        ></v-textarea>
        <!-- <v-checkbox label="Ja" v-model="preCheckTech"></v-checkbox> -->
      </div>

      <div class="text-center my-2">
        <v-progress-circular v-if="paymentDataLoading" indeterminate></v-progress-circular>
        <template v-else-if="item.amount">
          <div class="headline font-weight-bold">{{item.amount}}:-</div>
          <div class="text--secondary"> inkl. moms</div>
          <div class="text--secondary body-2"> {{item.amount_ex_vat.toFixed(2).replace('.', ',')}} kr exkl. moms</div>
        </template>
      </div>

      <div class="" v-if="isRequest">
        Med de valda tillvalen kommer bokningen skickas som en förfrågan. Godtages förfrågan får ni bekräftelse via mail och sms.
      </div>
    </div>
    <v-btn class="mr-3" color="primary" @click="onContinue" :disabled="paymentDataLoading || getPaymentDataId != null">Fortsätt</v-btn>
    <v-btn text color="primary" @click="$emit('previous')">Tillbaka</v-btn>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import {getItemById} from '@dynapp/wc-api-generic';
import SeatingInput from '@/components/SeatingInput.vue';

export default {
  name: 'CustomBookingStep',
  props: {
    item: {
      default: () => ({})
    },
    calendar: {
      default: () => ({})
    },
    validNumber: {},
    active: {},
    isRequest: {},
    isRequestTooLate: {}
  },
  watch: {
    'item.guests': function (val) {
      this.cateringPackageCount = val;
      this.morningFikaCount = val;
      this.lunchCount = val;
      this.afternoonFikaCount = val;
    },
    cateringPackage() {
      this.setExtra(true);
    },
    morningFika() {
      this.setExtra(true);
    },
    lunch() {
      this.setExtra(true);
    },
    afternoonFika() {
      this.setExtra(true);
    },
    cateringPackageCount() {
      this.setExtra(true);
    },
    morningFikaCount() {
      this.setExtra(true);
    },
    lunchCount() {
      this.setExtra(true);
    },
    afternoonFikaCount() {
      this.setExtra(true);
    },
    needUplink() {
      this.setExtra();
    },
    preCheckTech() {
      this.setExtra();
    },
    cateringTime() {
      this.setExtra();
    },
    allergies() {
      this.setExtra();
    }
  },
  data() {
    return {
      cateringPackage: false,
      morningFika: false,
      lunch: false,
      afternoonFika: false,
      cateringPackageCount: null,
      morningFikaCount: null,
      lunchCount: null,
      afternoonFikaCount: null,
      needUplink: '',
      seating: '',
      preCheckTech: '',
      cateringTime: '',
      allergies: '',
      getPaymentDataId: null
    };
  },
  computed: {
    halfDay() {
      if (!this.item.from || !this.item.to) {
        return false;
      }
      if (moment(this.item.to).diff(moment(this.item.from), 'hours') < 5) {
        return true;
      }
      return false;
    },
    morning() {
      if (!this.item.from || !this.item.to) {
        return false;
      }
      if (moment(this.item.from).tz(this.calendar.timezone).format('HH:mm') < '12:00') {
        return true;
      }
      return false;
    },
    valueExtraFields() {
      var result = [];
      (this.calendar.extra_fields || []).forEach(section => {
        result = result.concat(section.fields || []);
      });
      return result;
    },
    products() {
      var productKeys = [
        'full_day_package_count',
        'morning_package_count',
        'afternoon_package_count',
        'morning_fika_count',
        'lunch_count',
        'afternoon_fika_count'
      ];
      var result = {};
      productKeys.forEach((key) => {
        result[key] = this.getProduct(key);
      });
      return result;
    },
    packageProduct() {
      if (this.halfDay) {
        if (this.morning) {
          return this.products.morning_package_count;
        } else {
          return this.products.afternoon_package_count;
        }
      } else {
        return this.products.full_day_package_count;
      }
    },
    paymentDataLoading() {
      return this.$store.getters.isLoadingFor('booking-public-payment.read');
    }
  },
  methods: {
    getProduct(key) {
      var field = getItemById(this.valueExtraFields, key, 'key');
      return getItemById(this.calendar.ftp_products, field.ftp_product_id);
    },
    onContinue() {
      // TODO: Validate?
      this.$emit('next');
    },
    setExtra(paymentChange) {
      var cateringPackageCount = parseInt(this.cateringPackageCount || this.item.guests);
      var morningFikaCount = parseInt(this.morningFikaCount || this.item.guests);
      var lunchCount = parseInt(this.lunchCount || this.item.guests);
      var afternoonFikaCount = parseInt(this.afternoonFikaCount || this.item.guests);

      // Figure out real counts based on options
      var catering = true;
      var full_day_package_count = catering && this.cateringPackage && !this.halfDay ? cateringPackageCount : 0;
      var morning_package_count = catering && this.cateringPackage && this.halfDay && this.morning ? cateringPackageCount : 0;
      var afternoon_package_count = catering && this.cateringPackage && this.halfDay && !this.morning ? cateringPackageCount : 0;
      var morning_fika_count = catering && !this.cateringPackage && this.morningFika ? morningFikaCount : 0;
      var lunch_count = catering && !this.cateringPackage && this.lunch ? lunchCount : 0;
      var afternoon_fika_count = catering && !this.cateringPackage && this.afternoonFika ? afternoonFikaCount : 0;

      var extra = {
        full_day_package_count,
        morning_package_count,
        afternoon_package_count,
        morning_fika_count,
        lunch_count,
        afternoon_fika_count
      };

      // Set catering
      if (catering) {
          var catering_string = '';

          if (full_day_package_count || morning_package_count || afternoon_package_count || morning_fika_count || lunch_count || afternoon_fika_count) {
              if (this.cateringTime) {
                  catering_string += '\nÖnskas vid:\n' + this.cateringTime + '\n';
              }
          }

          extra.catering = catering_string;
      }

      extra.equipment = '';
      if (this.needUplink) {
          extra.equipment += 'Behövs uppkoppling:\n' + this.needUplink + '\n';
      }
      if (this.preCheckTech) {
          extra.equipment += 'Önskar stämma av tekniken innan bokningen:\n' + this.preCheckTech + '\n';
      }

      if (this.allergies) {
          extra.allergies = this.allergies;
      }

      Object.keys(extra).forEach(function(key) {
          if (typeof extra[key] == 'string') {
              extra[key] = extra[key].trim();
          }
      });

      this.$set(this.item, 'extra', extra);

      if (paymentChange) {
        clearTimeout(this.getPaymentDataId)
        var getPaymentDataId = setTimeout(() => {
          this.getPaymentData(getPaymentDataId, {...this.item});
        }, 300);
        this.getPaymentDataId = getPaymentDataId;
      }
    },
    getPaymentData(getPaymentDataId, item) {
      if (!this.active || !item.from || !item.to) {
        this.getPaymentDataId = null;
        return;
      }
      this.$store.dispatch(`bookings-public/${this.calendar.id}/getPaymentData`, item).then(
        (resp) => {
          if (getPaymentDataId == this.getPaymentDataId) {
            this.$set(this.item, 'amount', resp.data.data.amount || null);
            this.$set(this.item, 'amount_ex_vat', resp.data.data.amount_ex_vat || null);
            this.$set(this.item, 'ftp_cart', resp.data.data.ftp_cart || null);
            this.getPaymentDataId = null;
          }
        },
        (err) => {
          console.error(err);
          this.$snackbar({message: 'Failed to get payment data', theme: 'error'});
        }
      );
    }
  },
  components: {
    SeatingInput
  }
}
</script>

<style lang="css" scoped>
</style>
